"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var unavailable_exports = {};
__export(unavailable_exports, {
  PhotoLibrary: () => PhotoLibrary
});
module.exports = __toCommonJS(unavailable_exports);
var import_nativeError = require("../nativeError");
var PhotoLibrary = Object.freeze({
  getAddPermissionStatus: function getAddPermissionStatus() {
    return "denied";
  },
  requestAddPermission: function requestAddPermission() {
    return Promise.resolve("denied");
  },
  getReadPermissionStatus: function getReadPermissionStatus() {
    return "denied";
  },
  requestReadPermission: function requestReadPermission() {
    return Promise.resolve("denied");
  },
  presentLimitedLibraryPicker: function presentLimitedLibraryPicker() {
    return Promise.resolve([]);
  },
  listAssets: function listAssets() {
    var _offset = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, _limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 50;
    return Promise.resolve({
      assets: [],
      totalCount: 0
    });
  },
  getAsset: function getAsset(_identifier) {
    return Promise.reject((0, import_nativeError.missingNativeBuild)("PhotoLibrary.getAsset"));
  },
  listAlbums: function listAlbums() {
    var _offset = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, _limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 50;
    return Promise.resolve({
      albums: [],
      totalCount: 0
    });
  },
  getAlbum: function getAlbum(_identifier) {
    return Promise.reject((0, import_nativeError.missingNativeBuild)("PhotoLibrary.getAlbum"));
  },
  createAlbum: function createAlbum(_title) {
    return Promise.reject((0, import_nativeError.missingNativeBuild)("PhotoLibrary.createAlbum"));
  },
  renameAlbum: function renameAlbum(_identifier, _title) {
    return Promise.resolve();
  },
  listAlbumAssets: function listAlbumAssets(_identifier) {
    var _offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, _limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 50;
    return Promise.resolve({
      assets: [],
      totalCount: 0
    });
  },
  addAssetToAlbum: function addAssetToAlbum(_albumIdentifier, _assetIdentifier) {
    return Promise.resolve();
  },
  removeAssetFromAlbum: function removeAssetFromAlbum(_albumIdentifier, _assetIdentifier) {
    return Promise.resolve();
  },
  deleteAlbum: function deleteAlbum(_identifier) {
    return Promise.resolve();
  },
  setFavorite: function setFavorite(_identifier, _favorite) {
    return Promise.resolve();
  },
  deleteAsset: function deleteAsset(_identifier) {
    return Promise.resolve();
  },
  replaceImageContent: function replaceImageContent(_identifier, _uri) {
    return Promise.resolve();
  },
  replaceVideoContent: function replaceVideoContent(_identifier, _uri) {
    return Promise.resolve();
  },
  revertAssetContent: function revertAssetContent(_identifier) {
    return Promise.resolve();
  },
  exportOriginalAsset: function exportOriginalAsset(_identifier) {
    var _allowNetwork = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return Promise.reject((0, import_nativeError.missingNativeBuild)("PhotoLibrary.exportOriginalAsset"));
  },
  exportCurrentImage: function exportCurrentImage(_identifier) {
    var _allowNetwork = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return Promise.reject((0, import_nativeError.missingNativeBuild)("PhotoLibrary.exportCurrentImage"));
  },
  exportCurrentVideo: function exportCurrentVideo(_identifier) {
    var _allowNetwork = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return Promise.reject((0, import_nativeError.missingNativeBuild)("PhotoLibrary.exportCurrentVideo"));
  },
  saveImage: function saveImage(_uri) {
    return Promise.reject((0, import_nativeError.missingNativeBuild)("PhotoLibrary.saveImage"));
  },
  saveVideo: function saveVideo(_uri) {
    return Promise.reject((0, import_nativeError.missingNativeBuild)("PhotoLibrary.saveVideo"));
  }
});
//# sourceMappingURL=unavailable.js.map
